module.exports = new __parcel__URL__("authorized-dealer.fbcd10d4.svg").toString();